import { ISLEntryGridItem } from "../schemas/SLEntryGridSchemas";
import { utils, writeFile } from "xlsx";
import { getFormattedDateString } from "./DateUtil";
import { IProcessingStatus } from "../components/SLEntriesDetails";

export function gridItemsToArrayOfArrays(
  data: ISLEntryGridItem[],
  processingStatus: IProcessingStatus["statuses"]
): Array<Array<string | number | null | boolean | undefined>> {
  return data.map((gridItem) => {
    const rowData = [
      gridItem.nameDocumentId,
      gridItem.companyCode,
      gridItem.description,
      gridItem.status,
      gridItem.poster,
      gridItem.additionalPoster,
      gridItem.reviewers,
      gridItem.fiscalYearAndPeriod,
      gridItem.comments,
      getFormattedDateString(gridItem.modifiedDate),
      gridItem.format,
      gridItem.attachmentFileName
    ];
    if (gridItem.slEntryId in processingStatus) {
      rowData.push(processingStatus[gridItem.slEntryId].messages.join());
    } else {
      rowData.push("");
    }
    return rowData;
  });
}

export function ExportToExcel(
  headers: string[],
  data: ISLEntryGridItem[],
  processingStatus: IProcessingStatus["statuses"],
  workbookName = "subledgerExport.xlsx"
): void {
  const excelRows = [headers, ...gridItemsToArrayOfArrays(data, processingStatus)];

  const workSheetName = "GridItems";
  const workBook = utils.book_new();
  const workSheet = utils.aoa_to_sheet(excelRows);
  utils.book_append_sheet(workBook, workSheet, workSheetName);
  writeFile(workBook, workbookName);
}
